import { HammerGestureConfig } from '@angular/platform-browser';
import { Injectable } from '@angular/core';
import 'hammerjs';

@Injectable()
export class HammerConfig extends HammerGestureConfig {
  buildHammer(element: HTMLElement) {
    const mc = new (window as any).Hammer(element, {
      touchAction: 'auto',
    });
    return mc;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/hammer.config.ts